module.exports = __webpack_public_path__ + "img/rating-reviews.ab471e0b.png";